import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { HelpCircleIcon, MinusIcon, PlusIcon, SettingsIcon, MailIcon } from "lucide-react";
import { OBJECTIONS } from "../data/content";
export function Objections() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="px-5 py-8" data-id="element-178" data-mp="hjtdphfh18bp">
      <div className="mb-5 flex items-center justify-center gap-2" data-id="element-179" data-mp="hmyzonsszu37">
        <HelpCircleIcon className="h-5 w-5 text-[#d4ff00]" data-id="element-180" data-mp="cml25zotw2jf" />
        <h2 className="text-center font-display text-2xl uppercase text-white" data-id="element-181" data-mp="7vbeh4mub9a6">
          ¿Tienes dudas?
        </h2>
      </div>

      <div className="flex flex-col gap-2.5" data-id="element-182" data-mp="3uj2i3ml2qa7">
        {OBJECTIONS.map((o, i) => {
        const isOpen = open === i;
        return <div key={i} className="overflow-hidden rounded-2xl border border-white/10 bg-black/50" data-id="element-183" data-mp="3uxy0xy4swe6r" data-mpi={i}>
              <button type="button" onClick={() => setOpen(isOpen ? null : i)} className="flex w-full items-center gap-3 px-4 py-3.5 text-left" aria-expanded={isOpen} data-id="element-184" data-mp="3l1bith3v018f">
                <span className="flex-1 text-sm font-bold text-white" data-id="element-185" data-mp="59topnh8kr6y">
                  {o.q}
                </span>
                {isOpen ? <MinusIcon className="h-5 w-5 shrink-0 text-[#d4ff00]" data-id="element-186" data-mp="3rmigm1fak678" /> : <PlusIcon className="h-5 w-5 shrink-0 text-[#d4ff00]" data-id="element-187" data-mp="j78ggyuypb23" />}
              </button>
              <AnimatePresence initial={false} data-id="element-188" data-mp="o5jrve0wntmf">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.25
            }} data-id="element-189" data-mp="99u1z4slmwcf">
                    <p className="border-t border-white/10 px-4 py-3 text-[13px] leading-relaxed text-white/70" data-id="element-190" data-mp="2yymkoyxjqibi">
                      {o.a}
                    </p>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>

      {/* Support */}
      <div className="mt-6 flex flex-col items-center gap-2 rounded-2xl border border-white/10 bg-black/40 p-5 text-center" data-id="element-191" data-mp="vpudvg62smvb">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-[#d4ff00]/15" data-id="element-192" data-mp="qpznddq7pzas">
          <SettingsIcon className="h-6 w-6 text-[#d4ff00]" data-id="element-193" data-mp="lszdssu5meex" />
        </div>
        <p className="text-[13px] font-semibold text-white" data-id="element-194" data-mp="hqkz8kxiq0tg">Soporte</p>
        <a href="mailto:EbookDreamShop@gmail.com" className="flex items-center gap-1.5 text-[13px] text-white/70 underline" data-id="element-195" data-mp="hspa5mtu4038">
          <MailIcon className="h-4 w-4" data-id="element-196" data-mp="7t6s5bxhiodt" />
          EbookDreamShop@gmail.com
        </a>
      </div>
    </section>;
}